<template>
  <div class="template-designer-container">
    <div class="designer-main">
      <!-- 左侧：画布区域 -->
      <div class="canvas-section">
        <div class="canvas-header">
          <span class="canvas-title">收据预览</span>
          <span class="canvas-size">实际尺寸: {{ layer1Config.width }}x{{ layer1Config.height }}px</span>
          <el-button type="primary" size="small" @click="saveTemplate">保存模板</el-button>
        </div>
        
        <!-- 缩放控制 -->
        <div class="scale-controls">
          <el-button size="mini" @click="adjustScale(-0.1)">-</el-button>
          <span>{{ Math.round(displayScale * 100) }}%</span>
          <el-button size="mini" @click="adjustScale(0.1)">+</el-button>
          <el-button size="mini" @click="displayScale = 0.75">75%</el-button>
          <el-button size="mini" @click="displayScale = 1">100%</el-button>
        </div>

        <!-- 设计画布 -->
        <div class="canvas-wrapper">
          <!-- 第一联（客户联） -->
          <div
            ref="customerCanvas"
            class="design-canvas"
            :style="{ width: layer1Config.width * displayScale + 'pt', height: layer1Config.height * 0.5 * displayScale + 'pt' }"
            @dragover.prevent
            @drop="handleDrop"
            @click="handleCanvasClick"
          >
                <!-- 底部防伪层（底图） -->
                <div v-if="layer1Config.watermarkImage" class="watermark-layer" :style="getWatermarkLayerStyle()">
                </div>

                <!-- 客户联标识 -->
                <div v-if="layer1Config.duplex" class="copy-label">客户联</div>

                <!-- 收据标题区域 -->
                <div class="receipt-header" :style="getHeaderStyle()">
                  <div class="receipt-title">{{ communityName || '演示小区' }}收据单</div>
                  <div class="receipt-subtitle">单号：{{ receiptNo }}</div>
                </div>

                <!-- 固定头部参数 -->
                <div class="header-info" :style="getHeaderInfoStyle()">
                  <div class="info-row">
                    <span class="info-label">业主：</span>
                    <span class="info-value">{{ payName }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">缴费时间：</span>
                    <span class="info-value">{{ receiptDate }}</span>
                  </div>
                </div>

                <!-- 收据表格 -->
                <div class="receipt-table-wrapper" :style="getTableWrapperStyle()">
                  <table class="receipt-table" :style="getTableStyle()">
                    <thead>
                      <tr>
                        <th v-for="(col, index) in (layer2Config.tableColumns || [])" :key="'th-' + index" :style="getColumnStyle(col)">
                          {{ col.header }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="receipt-table-body">
                      <tr v-for="(row, rowIndex) in tableData" :key="'tr-' + rowIndex">
                        <td v-for="(col, colIndex) in (layer2Config.tableColumns || [])" :key="'td-' + rowIndex + '-' + colIndex" :style="getColumnStyle(col)">
                          {{ row[col.field] || '-' }}
                        </td>
                      </tr>
                      <!-- 合计行 -->
                      <tr class="total-row">
                        <td :colspan="totalColspan" class="total-label">大写人民币（元）</td>
                        <td :colspan="totalColspanEnd" class="total-value">{{ uppercaseAmount }}</td>
                      </tr>
                      <!-- 金额合计行 -->
                      <tr class="amount-total-row">
                        <td :colspan="totalColspan - 1" style="border: 1px solid #ccc; padding: 2pt; text-align: center; font-weight: bold;">合计</td>
                        <td :colspan="totalColspanEnd + 1" style="border: 1px solid #ccc; padding: 2pt; text-align: center; font-weight: bold;">¥{{ totalAmount }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- 固定底部参数 -->
                <div :style="getFooterStyle()">
                  <div style="text-align: left; width: 25%;">部门负责人</div>
                  <div style="text-align: left; width: 25%;">经办人：{{ collector }}</div>
                  <div style="text-align: left; width: 25%;">财务收款：</div>
                  <div style="text-align: left; width: 25%;">客户确认：</div>
                </div>

                <!-- 中间数据层：数据标签 -->
                <div
                  v-for="label in (layer2Config.labels || [])"
                  :key="label.id"
                  class="data-label"
                  :style="getLabelStyle(label)"
                  @click.stop="selectLabel(label)"
                  @dblclick.stop="editLabel(label)"
                  @mousedown="startDrag(label, $event)"
                >
                  {{ label.label }}：<span style="border-bottom:1px solid #333;min-width:50pt;display:inline-block;">&nbsp;</span>
                </div>

                <!-- 顶部印章层 -->
                <div v-if="layer3Config.enabled && layer3Config.stampImage" class="stamp-layer">
                  <img
                    :key="'stamp-' + layer3Config.xPercent + '-' + layer3Config.yPercent"
                    :src="layer3Config.stampImage"
                    :style="{
                      position: 'absolute',
                      left: layer3Config.xPercent + '%',
                      top: layer3Config.yPercent + '%',
                      width: 'auto',
                      height: 'auto',
                      opacity: layer3Config.opacity / 100,
                      cursor: 'move',
                      transform: 'translate(-50%, -50%)'
                    }"
                    @click="selectStamp"
                    @mousedown="startDragStamp($event)"
                    @mouseup="stopDragStamp"
                    @mouseleave="stopDragStamp"
                  />
                </div>
          </div>

              <!-- 第二联（存根联）- 纯显示层，无事件监听，纯内联样式 -->
              <div v-if="layer1Config.duplex"
                style="position: relative; flex-shrink: 0; background: #fff; border: 2px solid #409EFF;"
                :style="{ width: layer1Config.width * displayScale + 'pt', height: layer1Config.height * 0.5 * displayScale + 'pt' }"
              >
                <!-- 底部防伪层（底图） -->
                <div v-if="layer1Config.watermarkImage" class="watermark-layer" :style="getWatermarkLayerStyle()">
                </div>

                <!-- 存根联标识 -->
                <div style="position: absolute; top: 8pt; right: 10pt; font-size: 12pt; font-weight: bold; color: #f00; border: 2px solid #f00; padding: 4pt 10pt; z-index: 100; background: rgba(255, 255, 255, 0.9);">存根联</div>

                <!-- 收据标题区域 -->
                <div :style="getHeaderStyle()">
                  <div>{{ communityName || '演示小区' }}</div>
                  <div>单号：{{ receiptNo }}</div>
                </div>

                <!-- 固定头部参数 -->
                <div :style="getHeaderInfoStyle()">
                  <div><span>业主：</span><span>{{ payName }}</span></div>
                  <div><span>缴费时间：</span><span>{{ receiptDate }}</span></div>
                </div>

                <!-- 收据表格 -->
                <div :style="getTableWrapperStyle()">
                  <table :style="getTableStyle()">
                    <thead>
                      <tr>
                        <th v-for="(col, index) in (layer2Config.tableColumns || [])" :key="'stub-th-' + index" :style="getColumnStyle(col)">
                          {{ col.header }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="receipt-table-body">
                      <tr v-for="(row, rowIndex) in tableData" :key="'stub-tr-' + rowIndex">
                        <td v-for="(col, colIndex) in (layer2Config.tableColumns || [])" :key="'stub-td-' + rowIndex + '-' + colIndex" :style="getColumnStyle(col)">
                          {{ row[col.field] || '-' }}
                        </td>
                      </tr>
                      <!-- 合计行 -->
                      <tr class="total-row">
                        <td :colspan="totalColspan" style="border: 1px solid #ccc; padding: 2pt; text-align: center; font-weight: bold;">大写人民币（元）</td>
                        <td :colspan="totalColspanEnd" style="border: 1px solid #ccc; padding: 2pt; text-align: center; font-weight: bold;">{{ uppercaseAmount }}</td>
                      </tr>
                      <!-- 金额合计行 -->
                      <tr class="amount-total-row">
                        <td :colspan="totalColspan - 1" style="border: 1px solid #ccc; padding: 2pt; text-align: center; font-weight: bold;">合计</td>
                        <td :colspan="totalColspanEnd + 1" style="border: 1px solid #ccc; padding: 2pt; text-align: center; font-weight: bold;">¥{{ totalAmount }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- 固定底部参数 -->
                <div :style="getFooterStyle()">
                  <div style="text-align: left; width: 30%;">经办人：{{ collector }}</div>
                  <div style="text-align: left; width: 30%;">财务收款：</div>
                  <div style="text-align: left; width: 30%;">客户确认：</div>
                </div>

                <!-- 中间数据层：数据标签（纯显示，无事件） -->
                <div
                  v-for="label in (layer2Config.labels || [])"
                  :key="'stub-label-' + label.xPercent + '-' + label.yPercent"
                  :style="getLabelStyle(label)"
                >
                  {{ label.label }}：<span style="border-bottom:1px solid #333;min-width:50pt;display:inline-block;">&nbsp;</span>
                </div>

                <!-- 顶部印章层（纯显示，无事件） -->
                <div v-if="layer3Config.enabled && layer3Config.stampImage">
                  <img
                    :key="'stub-stamp-' + layer3Config.xPercent + '-' + layer3Config.yPercent"
                    :src="layer3Config.stampImage"
                    :style="{
                      position: 'absolute',
                      left: layer3Config.xPercent + '%',
                      top: layer3Config.yPercent + '%',
                      width: 'auto',
                      height: 'auto',
                      opacity: layer3Config.opacity / 100,
                      cursor: 'default',
                      transform: 'translate(-50%, -50%)'
                    }"
                  />
                </div>
              </div>
            </div>
          </div>

      <!-- 右侧：配置面板 -->
      <div class="config-section">
        <div class="config-tabs-wrapper">
          <el-tabs v-model="activeTab" type="card">
            <!-- 基础设置 -->
            <el-tab-pane label="基础设置" name="layer1">
            <el-form :model="layer1Config" label-width="120px">
              <el-form-item label="模板名称">
                <el-input v-model="layer1Config.templateName" placeholder="请输入模板名称" />
              </el-form-item>
              <el-form-item label="纸张宽度(px)">
                <el-input type="number" v-model.number="layer1Config.width" />
                <span class="size-tip">A4纸宽度约595px</span>
              </el-form-item>
              <el-form-item label="纸张高度(px)">
                <el-input type="number" v-model.number="layer1Config.height" />
                <span class="size-tip">A4纸高度约842px</span>
              </el-form-item>
              <el-form-item label="两联收据">
                <el-switch v-model="layer1Config.duplex" />
              </el-form-item>
              <el-form-item label="底图上传">
                <el-upload
                  class="upload-demo"
                  :action="''"
                  :http-request="handleWatermarkUploadRequest"
                  :show-file-list="false"
                  accept="image/*"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <div v-if="layer1Config.watermarkImage" class="preview-box">
                  <img :src="layer1Config.watermarkImage" class="preview-img" />
                  <el-button size="mini" @click="clearWatermark">清除</el-button>
                </div>
              </el-form-item>
              <el-form-item label="底图透明度">
                <el-slider v-model="layer1Config.watermarkOpacity" :min="0" :max="100" />
                <span>{{ layer1Config.watermarkOpacity }}%</span>
              </el-form-item>
              <el-form-item label="底图显示方式">
                <el-select v-model="layer1Config.watermarkMode">
                  <el-option label="拉伸填充" value="stretch" />
                  <el-option label="居中显示" value="center" />
                  <el-option label="多图平铺" value="multiTile" />
                </el-select>
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <!-- 表格配置 -->
          <el-tab-pane label="表格配置" name="layer2">
            <div class="table-config">
              <div class="table-columns-header">
                <span>表格列配置</span>
                <el-button size="mini" type="primary" @click="addColumn">+ 添加列</el-button>
              </div>
              
              <div v-if="!layer2Config.tableColumns || layer2Config.tableColumns.length === 0" class="empty-tip">
                暂无列，请点击上方按钮添加
              </div>
              
              <div v-for="(col, index) in (layer2Config.tableColumns || [])" :key="index" class="column-item">
                <el-form :model="col" inline>
                  <el-form-item label="列标题">
                    <el-input size="small" v-model="col.header" :placeholder="'列' + (index + 1)" />
                  </el-form-item>
                  <el-form-item label="绑定字段">
                    <el-select size="small" v-model="col.field" placeholder="选择字段">
                      <el-option
                        v-for="field in tableFields"
                        :key="field.value"
                        :label="field.label"
                        :value="field.value"
                        :title="field.label + ' → ' + field.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="宽度(pt)">
                    <el-input size="small" type="number" v-model.number="col.widthPt" />
                  </el-form-item>
                  <el-button size="mini" type="danger" @click="removeColumn(index)" v-if="layer2Config.tableColumns && layer2Config.tableColumns.length > 1">删除</el-button>
                </el-form>
              </div>

              <div class="table-rows-config">
                <el-form :model="layer2Config" inline>
                  <el-form-item label="默认行数">
                    <el-input type="number" v-model.number="layer2Config.defaultRows" />
                  </el-form-item>
                  <el-form-item label="行高(px)">
                    <el-input type="number" v-model.number="layer2Config.rowHeight" />
                  </el-form-item>
                </el-form>
              </div>

              <div class="field-list">
                <h4>标签字段（拖拽或点击添加到画布）</h4>
                <div
                  v-for="field in labelFields"
                  :key="field.value"
                  class="field-item"
                  draggable="true"
                  @dragstart="handleDragStart(field)"
                  @click="handleFieldClick(field)"
                >
                  {{ field.label }}
                </div>
              </div>

              <div class="label-list" v-if="layer2Config.labels && layer2Config.labels.length > 0">
                <h4>已添加标签</h4>
                <el-table :data="layer2Config.labels" border size="small">
                  <el-table-column label="标签名" prop="label" />
                  <el-table-column label="字段" prop="field" />
                  <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button size="mini" type="text" @click="editLabel(scope.row)">编辑</el-button>
                      <el-button size="mini" type="text" @click="deleteLabel(scope.row.id)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>

          <!-- 印章配置 -->
          <el-tab-pane label="印章配置" name="layer3">
            <el-form :model="layer3Config" label-width="120px">
              <el-form-item label="启用印章">
                <el-switch v-model="layer3Config.enabled" />
              </el-form-item>
              <el-form-item label="印章图片" v-if="layer3Config.enabled">
                <el-upload
                  class="upload-demo"
                  :action="''"
                  :http-request="handleStampUploadRequest"
                  :show-file-list="false"
                  accept="image/*"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <div v-if="layer3Config.stampImage" class="preview-box">
                  <img :src="layer3Config.stampImage" class="preview-img stamp-preview" />
                  <el-button size="mini" @click="clearStamp">清除</el-button>
                </div>
              </el-form-item>
              <el-form-item label="提示" v-if="layer3Config.enabled">
                <div style="color: #909399; font-size: 12px; line-height: 1.5;">
                  💡 请在右侧预览区域直接拖动印章到合适位置<br/>
                  📌 两联模式下，拖动任一联的印章会同步调整另一联
                </div>
              </el-form-item>
              <el-form-item label="透明度" v-if="layer3Config.enabled">
                <el-slider v-model="layer3Config.opacity" :min="0" :max="100" />
                <span>{{ layer3Config.opacity }}%</span>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 标签编辑对话框 -->
    <el-dialog title="编辑标签" :visible.sync="labelEditVisible" width="400px">
      <el-form :model="editingLabel" label-width="100px">
        <el-form-item label="标签名">
          <el-input v-model="editingLabel.label" />
        </el-form-item>
        <el-form-item label="绑定字段">
          <el-select v-model="editingLabel.field" placeholder="请选择字段">
            <el-option
              v-for="field in labelFields"
              :key="field.value"
              :label="field.label"
              :value="field.value"
              :title="field.label + ' → ' + field.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="X位置(%)">
          <el-slider v-model="editingLabel.xPercent" :min="0" :max="100" show-input />
        </el-form-item>
        <el-form-item label="Y位置(%)">
          <el-slider v-model="editingLabel.yPercent" :min="0" :max="100" show-input />
        </el-form-item>
        <el-form-item label="字号(%)">
          <el-slider v-model="editingLabel.fontSizePercent" :min="1" :max="5" show-input />
          <span class="size-tip">相对于纸张宽度的百分比</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="labelEditVisible = false">取消</el-button>
        <el-button type="primary" @click="saveLabelEdit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</div>
</template>

<script>
import request from '@/utils/request'
import { saveFeePrintPageTemplate } from '@/api/system/feePrintPageManageApi'
import { getCommunityId } from '@/api/community/communityApi'
// 收据模板相关样式(从 <style scoped> 中提取)
const RECEIPT_STYLES = `
  /* 画布容器 */
  .design-canvas { background: #fff; border: 0; position: relative; flex-shrink: 0; }
  
  /* 收据标题区域 */
  .receipt-header { text-align: center; }
  .receipt-title { font-size: 1.6em; }
  .receipt-subtitle { font-size: 0.6em; color: #666; margin-top: 0; }
  
  /* 头部信息 */
  .header-info { display: flex; justify-content: space-between; }
  .info-row { margin-bottom: 0; }
  .info-label { font-weight: bold; }
  
  /* 表格区域 */
  .receipt-table-wrapper { overflow: auto; }
  .receipt-table { width: 100%; border-collapse: collapse; }
  .receipt-table th, .receipt-table td { border: 1px solid #ccc; padding: 2px; text-align: center; }
  .receipt-table th { background: #f5f5f5; font-weight: bold; }
  .total-row { background: #f9f9f9; }
  .amount-total-row { background: #e8f4ff; font-weight: bold; }
  .total-label { text-align: left; padding-left: 10px; }
  .total-value { text-align: right; padding-right: 10px; }
  
  /* 底部签名区 */
  .footer-info { display: flex; justify-content: space-between; }
  .footer-left, .footer-center, .footer-right { text-align: center; width: 25%; }
  
  /* 水印和印章层 */
  .watermark-layer { position: absolute; top: 0; left: 0; right: 0; bottom: 0; pointer-events: none; z-index: 0; }
  .stamp-layer { position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 20; pointer-events: none; }
  .stamp-layer img { opacity: 0.8; pointer-events: auto; }
  
  /* 联次标识 */
  .copy-label { position: absolute; top: 8px; right: 10px; font-size: 16px; font-weight: bold; color: #f00; border: 2px solid #f00; padding: 4px 10px; z-index: 100; background: rgba(255, 255, 255, 0.9); }
  
  /* 数据标签 */
  .data-label { cursor: move; padding: 4px 8px; background: rgba(255, 255, 0, 0.3); border: 1px dashed #333; white-space: nowrap; z-index: 10; }
`

export default {
  name: 'TemplateColumnDesigner',
  data() {
    return {
      activeTab: 'layer1',
      dragField: null,
      selectedLabel: null,
      labelEditVisible: false,
      editingLabel: {},
      isDragging: false,
      isDraggingStamp: false,  // 印章拖动标志位
      displayScale: 1,
      receiptNo: '202606002(102026061395480020)',
      payName: '测试业主',
      receiptDate: '2026-06-13 19:58:46',
      collector: '演示物业',
      communityName: '演示小区',
      layer1Config: {
        templateName: '演示小区 收据单',
        width: 595,
        height: 842,
        duplex: false,
        watermarkImage: '',
        watermarkOpacity: 30,
        watermarkMode: 'stretch'
      },
      layer2Config: {
        labels: [],
        defaultRows: 2,
        rowHeight: 30,
        tableColumns: [
          { header: '编号', field: 'rowIndex', widthPt: 30 },
          { header: '收费项目', field: 'feeName', widthPt: 70 },
          { header: '房屋/车辆', field: 'objName', widthPt: 70 },
          { header: '收费范围', field: 'feePeriod', widthPt: 100 },
          { header: '周期', field: 'period', widthPt: 45 },
          { header: '单价/固定费', field: 'unitPrice', widthPt: 60 },
          { header: '面积/用量', field: 'area', widthPt: 45 },
          { header: '支付方式', field: 'payMethod', widthPt: 45 },
          { header: '金额', field: 'amount', widthPt: 45 },
          { header: '优惠金额', field: 'discount', widthPt: 45 },
          { header: '备注', field: 'remark', widthPt: 45 }
        ]
      },
      layer3Config: {
        enabled: false,
        stampImage: '',
        xPercent: 50,  // 默认居中
        yPercent: 50,  // 默认居中
        sizePercent: 15,
        opacity: 100
      },
      tableFields: [
        // ===== 表格字段：来自 queryFeeReceiptDetail 明细API，每条明细数据一行 =====
        { label: '编号', value: 'rowIndex' },
        { label: '收费项目', value: 'feeName' },
        { label: '房屋/车辆', value: 'objName' },
        { label: '收费范围', value: 'feePeriod' },
        { label: '周期', value: 'period' },
        { label: '单价/固定费', value: 'unitPrice' },
        { label: '面积/用量', value: 'area' },
        { label: '支付方式', value: 'payMethod' },
        { label: '金额', value: 'amount' },
        { label: '应收金额', value: 'receivableAmount' },
        { label: '优惠金额', value: 'discount' },
        { label: '备注', value: 'remark' },
        { label: '开始时间', value: 'startTime' },
        { label: '结束时间', value: 'endTime' },
        { label: '上期度数', value: 'preDegrees' },
        { label: '本期度数', value: 'curDegrees' },
        { label: '单位', value: 'units' },
        { label: '账户抵扣', value: 'acctAmount' }
      ],
      labelFields: [
        // ===== 标签字段：来自 queryFeeReceipt 收据主表API，整张收据共用 =====
        { label: '收据编号', value: 'receiptNo' },
        { label: '收款日期', value: 'receiptDate' },
        { label: '缴费人', value: 'payName' },
        { label: '小区名称', value: 'communityName' },
        { label: '收费员', value: 'collector' },
        { label: '操作员', value: 'operator' },
        { label: '大写金额', value: 'uppercaseAmount' },
        { label: '合计金额', value: 'totalAmount' }
      ],
      availableFields: [
        // 保留兼容（旧代码可能引用），实际使用 tableFields / labelFields
        { label: '收据编号', value: 'receiptNo' },
        { label: '收款日期', value: 'receiptDate' },
        { label: '缴费人', value: 'payName' },
        { label: '房屋/车辆', value: 'objName' },
        { label: '收费项目', value: 'feeName' },
        { label: '金额', value: 'amount' },
        { label: '小区名称', value: 'communityName' },
        { label: '备注', value: 'remark' },
        { label: '操作员', value: 'operator' },
        { label: '收费员', value: 'collector' },
        { label: '收费范围', value: 'feePeriod' },
        { label: '周期', value: 'period' },
        { label: '单价', value: 'unitPrice' },
        { label: '面积', value: 'area' },
        { label: '支付方式', value: 'payMethod' },
        { label: '优惠金额', value: 'discount' },
        { label: '编号', value: 'rowIndex' }
      ]
    }
  },
  computed: {
    tableData() {
      const rows = []
      const defaultRows = this.layer2Config.defaultRows || 2
      for (let i = 0; i < defaultRows; i++) {
        rows.push({
          rowIndex: this.receiptNo,
          feeName: '测试物业费' + (i + 1),
          objName: '99-1-101',
          feePeriod: '2026-02至2026-03',
          period: '1.19',
          unitPrice: '1.8/0.0',
          area: '189.00',
          payMethod: '平账金',
          amount: '406.03',
          discount: '',
          remark: '测试' + (i + 1)
        })
      }
      return rows
    },
    totalColspan() {
      const cols = this.layer2Config.tableColumns || []
      return Math.floor(cols.length / 3)
    },
    totalColspanEnd() {
      const cols = this.layer2Config.tableColumns || []
      return cols.length - Math.floor(cols.length / 3)
    },
    // 计算总金额（动态计算）
    totalAmount() {
      const cols = this.layer2Config.tableColumns || []
      const amountCol = cols.find(c => c.field === 'amount')
      if (!amountCol) return '0.00'
      const total = this.tableData.reduce((sum, row) => {
        const val = parseFloat(row.amount) || 0
        return sum + val
      }, 0)
      return total.toFixed(2)
    },
    // 动态计算大写金额
    uppercaseAmount() {
      const cols = this.layer2Config.tableColumns || []
      const amountCol = cols.find(c => c.field === 'amount')
      if (!amountCol) return '零'
      const total = this.tableData.reduce((sum, row) => {
        const val = parseFloat(row.amount) || 0
        return sum + val
      }, 0)
      return this.numberToChinese(total)
    },
    canvasStyle() {
      return {
        width: '100%',
        height: '100%',
        background: '#fff',
        border: '1px solid #ddd',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
        transform: 'scale(1)',
        transformOrigin: 'top left'
      }
    },
    watermarkStyle() {
      const opacity = this.layer1Config.watermarkOpacity / 100
      if (this.layer1Config.watermarkMode === 'multiTile') {
        return { width: '100%', height: '100%', objectFit: 'none', opacity }
      } else if (this.layer1Config.watermarkMode === 'center') {
        return { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', opacity, margin: 'auto', display: 'block' }
      } else {
        return { width: '100%', height: '100%', objectFit: 'cover', opacity }
      }
    },
  },
  methods: {
    // 获取水印层样式
    getWatermarkLayerStyle() {
      const opacity = this.layer1Config.watermarkOpacity / 100
      const mode = this.layer1Config.watermarkMode
      
      if (mode === 'multiTile') {
        // 平铺模式：使用背景图，按实际大小重复
        return {
          backgroundImage: `url(${this.layer1Config.watermarkImage})`,
          backgroundRepeat: 'repeat',
          backgroundSize: 'auto',  // 保持图片原始尺寸
          opacity: opacity
        }
      } else if (mode === 'center') {
        // 居中模式：单张图片居中显示
        return {
          backgroundImage: `url(${this.layer1Config.watermarkImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          opacity: opacity
        }
      } else {
        // 拉伸模式（默认）：铺满整个区域
        return {
          backgroundImage: `url(${this.layer1Config.watermarkImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%',
          opacity: opacity
        }
      }
    },
    // 获取印章样式
    getStampStyle(isFirstCopy) {
      const stampSize = this.layer1Config.width * (this.layer3Config.sizePercent / 100)
      
      // 如果是两联模式的第二联，需要调整Y坐标
      let yPercent = this.layer3Config.yPercent
      if (this.layer1Config.duplex && !isFirstCopy) {
        yPercent = yPercent + 50
      }
      
      const style = {
        position: 'absolute',
        left: this.layer3Config.xPercent + '%',
        top: yPercent + '%',
        width: stampSize * this.displayScale + 'px',
        height: stampSize * this.displayScale + 'px',
        opacity: this.layer3Config.opacity / 100,
        cursor: 'move',
        transform: 'translate(-50%, -50%)'
      }
      
      /* eslint-disable no-console */
      console.log('getStampStyle 被调用:', { 
        isFirstCopy,
        xPercent: this.layer3Config.xPercent,
        yPercent: this.layer3Config.yPercent,
        calculatedY: yPercent
      })
      
      return style
    },
    // 数字转中文大写（简化版）
    numberToChinese(num) {
      if (!num || isNaN(num)) return '零'
      const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
      const unit = ['元', '万', '亿', '亿']
      const intPart = Math.floor(num)
      const decPart = Math.round((num - intPart) * 100)
      
      let result = ''
      let intStr = intPart.toString()
      let unitIndex = 0
      
      // 从低位到高位处理
      while (intStr.length > 0) {
        let section = parseInt(intStr.slice(-4), 10)
        let sectionStr = ''
        
        for (let i = 0; i < 4 && section > 0; i++) {
          const d = section % 10
          sectionStr = digit[d] + (i === 0 ? '' : ['', '拾', '佰', '仟'][i]) + sectionStr
          section = Math.floor(section / 10)
        }
        
        if (sectionStr) {
          result = sectionStr + unit[unitIndex] + result
        } else if (unitIndex > 0 && result) {
          result = unit[unitIndex] + result
        }
        
        intStr = intStr.slice(0, -4)
        unitIndex++
      }
      
      // 处理小数部分
      if (decPart > 0) {
        const decInt = Math.floor(decPart / 10)
        const decDec = decPart % 10
        if (decInt > 0) {
          result += digit[decInt] + '角'
        }
        if (decDec > 0) {
          result += digit[decDec] + '分'
        }
      } else {
        result += '整'
      }
      
      return result || '零'
    },
    adjustScale(delta) {
      this.displayScale = Math.max(0.3, Math.min(1.5, this.displayScale + delta))
    },
    getHeaderStyle() {
      const baseFontSize = Math.max(12, this.layer1Config.width * 0.025)
      return {
        textAlign: 'center',
        padding: '3pt 3pt',  // 进一步减小上下内边距
        fontSize: baseFontSize * this.displayScale + 'pt',
        fontWeight: 'bold'
      }
    },
    getHeaderInfoStyle() {
      const baseFontSize = Math.max(10, this.layer1Config.width * 0.014)
      // 头部信息：使用流式布局，在标题下方
      return {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '2pt 2%',  // 进一步减小上下内边距
        fontSize: baseFontSize * this.displayScale + 'pt',
        lineHeight: '1.3'  // 进一步减小行高
      }
    },
    getTableWrapperStyle() {
      // 表格：使用流式布局，在头部信息下方
      return {
        margin: '0',  // 移除外边距
        padding: '0 2%',  // 添加左右内边距，与其他元素保持一致
        overflow: 'visible'
      }
    },
    getTableStyle() {
      return {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: this.layer1Config.width * 0.012 * this.displayScale + 'pt'
      }
    },
    getColumnStyle(col) {
      if (!col) return {}
      return {
        width: (col.widthPt || 50) + 'pt',
        border: '1px solid #ccc',
        padding: '2pt',
        textAlign: 'center',
        fontSize: 'inherit'
      }
    },
    getFooterStyle() {
      // 底部签名：使用流式布局，紧接在表格下方
      return {
        marginTop: '0',  // 移除外边距
        padding: '2pt 2%',  // 进一步减小上下内边距
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: this.layer1Config.width * 0.015 * this.displayScale + 'pt'
      }
    },
    addColumn() {
      if (!this.layer2Config.tableColumns) {
        this.layer2Config.tableColumns = []
      }
      this.layer2Config.tableColumns.push({
        header: '新列',
        field: '',
        widthPt: 50
      })
    },
    removeColumn(index) {
      if (this.layer2Config.tableColumns) {
        this.layer2Config.tableColumns.splice(index, 1)
      }
    },
    handleDragStart(field) {
      this.dragField = field
    },
    handleFieldClick(field) {
      if (!this.layer2Config.labels) {
        this.layer2Config.labels = []
      }
      const label = {
        id: Date.now(),
        label: field.label,
        field: field.value,
        xPercent: 10,
        yPercent: 10 + this.layer2Config.labels.length * 3,
        fontSizePercent: 2
      }
      this.layer2Config.labels.push(label)
    },
    handleDrop(event) {
      if (this.dragField) {
        if (!this.layer2Config.labels) {
          this.layer2Config.labels = []
        }
        const canvas = event.currentTarget
        const rect = canvas.getBoundingClientRect()
        const xPercent = ((event.clientX - rect.left) / rect.width) * 100
        const yPercent = ((event.clientY - rect.top) / rect.height) * 100

        this.layer2Config.labels.push({
          id: Date.now(),
          label: this.dragField.label,
          field: this.dragField.value,
          xPercent: Math.round(xPercent),
          yPercent: Math.round(yPercent),
          fontSizePercent: 2
        })
        this.dragField = null
      }
    },
    handleCanvasClick() {
      this.selectedLabel = null
    },
    getLabelStyle(label) {
      if (!label) return {}
      const fontSizePercent = label.fontSizePercent || 2
      const actualFontSize = this.layer1Config.width * (fontSizePercent / 100) * this.displayScale
      
      return {
        position: 'absolute',
        left: (label.xPercent || 10) + '%',
        top: (label.yPercent || 10) + '%',
        fontSize: actualFontSize + 'pt',
        cursor: 'move',
        padding: '4pt 8pt',
        background: 'rgba(255, 255, 0, 0.3)',
        border: '1px dashed #333',
        whiteSpace: 'nowrap',
        zIndex: 10
      }
    },
    selectLabel(label) {
      this.selectedLabel = label
    },
    editLabel(label) {
      this.editingLabel = { ...label }
      this.labelEditVisible = true
    },
    saveLabelEdit() {
      if (!this.layer2Config.labels) {
        this.layer2Config.labels = []
      }
      const index = this.layer2Config.labels.findIndex(l => l.id === this.editingLabel.id)
      if (index !== -1) {
        this.layer2Config.labels[index] = { ...this.editingLabel }
      }
      this.labelEditVisible = false
    },
    deleteLabel(id) {
      if (this.layer2Config.labels) {
        this.layer2Config.labels = this.layer2Config.labels.filter(l => l.id !== id)
      }
    },
    selectStamp() {},
    getCopySectionStyle() {
      return {
        position: 'relative',
        width: '100%',
        height: '100%'  // 始终100%，每个收据都是完整尺寸
      }
    },
    startDrag(label, event) {
      this.isDragging = true
      this.selectedLabel = label
      const canvas = event.currentTarget.parentElement  // .design-canvas
      const rect = canvas.getBoundingClientRect()

      const moveHandler = (e) => {
        if (this.isDragging && this.selectedLabel) {
          const xPercent = ((e.clientX - rect.left) / rect.width) * 100
          const yPercent = ((e.clientY - rect.top) / rect.height) * 100
          
          this.$set(this.selectedLabel, 'xPercent', Math.max(0, Math.min(100, Math.round(xPercent))))
          this.$set(this.selectedLabel, 'yPercent', Math.max(0, Math.min(100, Math.round(yPercent))))
        }
      }

      const upHandler = () => {
        this.isDragging = false
        document.removeEventListener('mousemove', moveHandler)
        document.removeEventListener('mouseup', upHandler)
      }

      document.addEventListener('mousemove', moveHandler)
      document.addEventListener('mouseup', upHandler)
    },

    startDragStamp(event) {
      /* eslint-disable no-console */
      console.log('startDragStamp 被调用')
      
      // 如果已经在拖动，忽略
      if (this.isDraggingStamp) {
        console.log('已经在拖动中，忽略')
        return
      }
      
      this.isDraggingStamp = true
      
      const stampElement = event.currentTarget
      const copySection = stampElement.parentElement.parentElement  // img -> .stamp-layer -> .copy-section
      const rect = copySection.getBoundingClientRect()
      const startMouseX = event.clientX
      const startMouseY = event.clientY
      const startXPercent = this.layer3Config.xPercent
      const startYPercent = this.layer3Config.yPercent
      
      console.log('=== 开始拖动印章 ===', { 
        初始位置: { x: startXPercent, y: startYPercent },
        联次区域尺寸: { width: rect.width, height: rect.height }
      })

      const moveHandler = (e) => {
        if (!this.isDraggingStamp) {
          console.log('moveHandler: isDraggingStamp=false，忽略')
          return
        }
        
        // 阻止默认行为，防止拖拽图片
        e.preventDefault()
        
        const deltaXPixel = e.clientX - startMouseX
        const deltaYPixel = e.clientY - startMouseY
        
        // 计算百分比偏移
        const deltaXPercent = (deltaXPixel / rect.width) * 100
        const deltaYPercent = (deltaYPixel / rect.height) * 100
        
        // 计算新的位置
        let newXPercent = startXPercent + deltaXPercent
        let newYPercent = startYPercent + deltaYPercent
        
        // 限制范围：X轴 0-100%，Y轴 0-100%
        newXPercent = Math.max(0, Math.min(100, newXPercent))
        newYPercent = Math.max(0, Math.min(100, newYPercent))
        
        // 更新配置（两联共享同一个位置）
        this.$set(this.layer3Config, 'xPercent', newXPercent)
        this.$set(this.layer3Config, 'yPercent', newYPercent)
        
        console.log('拖动中:', { x: newXPercent, y: newYPercent })
      }

      const upHandler = () => {
        console.log('upHandler 被调用！')
        console.log('=== 结束拖动印章 ===')
        console.log('最终位置:', { 
          x: this.layer3Config.xPercent, 
          y: this.layer3Config.yPercent 
        })
        
        this.isDraggingStamp = false
        document.removeEventListener('mousemove', moveHandler)
        document.removeEventListener('mouseup', upHandler)
        window.removeEventListener('mouseup', upHandler)
        console.log('已移除事件监听器')
      }

      document.addEventListener('mousemove', moveHandler)
      document.addEventListener('mouseup', upHandler)
      // 同时在 window 上监听，确保能捕获到 mouseup
      window.addEventListener('mouseup', upHandler)
      console.log('已添加事件监听器')
    },
    
    stopDragStamp() {
      /* eslint-disable no-console */
      if (this.isDraggingStamp) {
        console.log('stopDragStamp 被调用（元素级）')
        console.log('释放前的位置:', { x: this.layer3Config.xPercent, y: this.layer3Config.yPercent })
        this.isDraggingStamp = false
        console.log('=== 结束拖动印章（元素级） ===')
        console.log('释放后的位置:', { x: this.layer3Config.xPercent, y: this.layer3Config.yPercent })
      }
    },
    // 底图上传（自定义上传）
    handleWatermarkUploadRequest(options) {
      const file = options.file
      const formData = new FormData()
      formData.append('uploadFile', file)
      formData.append('communityId', getCommunityId())
      
      request({
        url: '/callComponent/upload/uploadFile/uploadImage',
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': undefined
        }
      }).then(response => {
        /* eslint-disable no-console */
        console.log('========================================')
        console.log('【底图上传返回】')
        console.log('完整返回:', response)
        console.log('response.data:', response.data)
        console.log('========================================')
        
        if (response && response.data) {
          const res = response.data
          // 尝试多种可能的返回格式
          let fileUrl = ''
          
          // 格式1: { fileUrl: '...' }
          if (res.fileUrl) {
            fileUrl = res.fileUrl
          }
          // 格式2: { data: { url: '...' } }
          else if (res.data && res.data.url) {
            fileUrl = res.data.url
          }
          // 格式3: { url: '...' }
          else if (res.url) {
            fileUrl = res.url
          }
          // 格式4: 直接返回字符串
          else if (typeof res === 'string') {
            fileUrl = res
          }
          
          console.log('提取的URL:', fileUrl)
          
          // 如果返回的是 jpg 路径，直接使用
          if (fileUrl) {
            this.$set(this.layer1Config, 'watermarkImage', fileUrl)
            console.log('✅ 已设置底图URL:', this.layer1Config.watermarkImage)
            console.log('💡 提示：请检查画布上是否显示底图')
            console.log('💡 如果未显示，请打开浏览器Network面板查看图片请求状态')
            this.$message.success('上传成功')
          } else {
            console.error('未找到有效的URL字段')
            this.$message.error('上传失败：未获取到文件URL')
          }
        } else {
          console.error('返回数据为空或格式错误')
          this.$message.error('上传失败：返回数据格式错误')
        }
      }).catch(error => {
        console.error('========================================')
        console.error('【底图上传失败】')
        console.error('错误信息:', error)
        console.error('========================================')
        this.$message.error('上传失败：' + (error.message || '未知错误'))
      })
    },
    clearWatermark() {
      this.layer1Config.watermarkImage = ''
    },
    // 印章上传（自定义上传）
    handleStampUploadRequest(options) {
      const file = options.file
      const formData = new FormData()
      formData.append('uploadFile', file)
      formData.append('communityId', getCommunityId())
      
      request({
        url: '/callComponent/upload/uploadFile/uploadImage',
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': undefined
        }
      }).then(response => {
        /* eslint-disable no-console */
        console.log('========================================')
        console.log('【印章上传返回】')
        console.log('完整返回:', response)
        console.log('response.data:', response.data)
        console.log('========================================')
        
        if (response && response.data) {
          const res = response.data
          // 尝试多种可能的返回格式
          let fileUrl = ''
          
          // 格式1: { fileUrl: '...' }
          if (res.fileUrl) {
            fileUrl = res.fileUrl
          }
          // 格式2: { data: { url: '...' } }
          else if (res.data && res.data.url) {
            fileUrl = res.data.url
          }
          // 格式3: { url: '...' }
          else if (res.url) {
            fileUrl = res.url
          }
          // 格式4: 直接返回字符串
          else if (typeof res === 'string') {
            fileUrl = res
          }
          
          console.log('提取的URL:', fileUrl)
          
          // 如果返回的是 jpg 路径，直接使用
          if (fileUrl) {
            this.$set(this.layer3Config, 'stampImage', fileUrl)
            this.$set(this.layer3Config, 'enabled', true)
            console.log('✅ 已设置印章URL:', this.layer3Config.stampImage)
            console.log('💡 提示：请检查画布上是否显示印章')
            console.log('💡 如果未显示，请打开浏览器Network面板查看图片请求状态')
            this.$message.success('上传成功')
          } else {
            console.error('未找到有效的URL字段')
            this.$message.error('上传失败：未获取到文件URL')
          }
        } else {
          console.error('返回数据为空或格式错误')
          this.$message.error('上传失败：返回数据格式错误')
        }
      }).catch(error => {
        console.error('========================================')
        console.error('【印章上传失败】')
        console.error('错误信息:', error)
        console.error('========================================')
        this.$message.error('上传失败：' + (error.message || '未知错误'))
      })
    },
    clearStamp() {
      this.layer3Config.stampImage = ''
      this.layer3Config.enabled = false
    },
    async saveTemplate() {
      if (!this.layer1Config.templateName.trim()) {
        this.$message.error('请先填写模板名称')
        return
      }

      try {
        // 预处理1：构建模板配置信息和固定JS内容
        const config = this.buildTemplateConfig()
        
        // 预处理2：处理DOM，生成收据HTML（支持双联）
        const receiptHTML = this.processReceiptDOM(config)
        
        // 预处理3：组装标准HTML文档
        const htmlContent = this.assembleHTMLTemplate(config, receiptHTML)

        // 使用浏览器原生 btoa 进行 Base64 编码（无需第三方依赖）
        const compressed = btoa(unescape(encodeURIComponent(htmlContent)))
        
        // 添加前缀标识这是Base64编码的HTML内容
        const dbValue = 'data:html;base64,' + compressed

        // 调用保存模板接口
        const saveTimestamp = Date.now()
        const templateId = 'TPL_' + saveTimestamp  // 生成唯一的模板ID
        
        console.log('【保存】URL: /feePrintPageTemplate.saveFeePrintPageTemplate | name=' + this.layer1Config.templateName + ' | templateId=' + templateId + ' | url长度=' + dbValue.length + '字节')
        
        try {
          // 保存模板信息到数据库（API函数已自动添加communityId）
          const saveResult = await saveFeePrintPageTemplate({
            name: this.layer1Config.templateName,
            templateId: templateId,
            url: dbValue  // 存储压缩后的HTML
          })

          // 检查保存结果
          if (saveResult && saveResult.code !== 0 && saveResult.code !== 200) {
            throw new Error(saveResult.msg || '保存模板信息失败')
          }

          this.$message.success('自定义模板保存成功，用户需再增加使用！')

          // 移除当前设计器标签，跳转到模板列表页
          const layout = this.$parent
          if (layout && layout.visitedTabs) {
            layout.visitedTabs = layout.visitedTabs.filter(t => t.path !== this.$route.path)
          }
          setTimeout(() => {
            this.$router.push('/pages/property/feePrintPageManage')
          }, 1000)
        } catch (saveError) {
          console.error('【保存失败】', saveError)
        }

      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败: ' + (error.message || '未知错误'))
      }
    },
    
    // ============================================
    // 【预处理函数1】buildTemplateConfig
    // 位置：templateColumnDesigner.vue 第1238行
    // 作用：构建模板配置信息和固定JS内容
    // ============================================
    /**
     * 预处理函数1：构建模板配置信息和固定JS内容
     * @returns {Object} 配置对象
     */
    buildTemplateConfig() {
      return {
        templateName: this.layer1Config.templateName,
        isDuplex: this.layer1Config.duplex,
        widthPt: this.layer1Config.width || 595,
        heightPt: this.layer1Config.height || 842,
        jsContent: this.generateInlineScript(),
        columns: this.layer2Config.tableColumns || []
      }
    },
    
    // ============================================
    // 【预处理函数2】processReceiptDOM
    // 位置：templateColumnDesigner.vue 第1263行
    // 作用：遍历单联DOM，处理样式替换、数据占位符替换，支持双联复制合并
    // ============================================

    processReceiptDOM(config) {
      const customerCanvas = this.$refs.customerCanvas
      if (!customerCanvas) {
        throw new Error('DOM元素未就绪，请稍后重试')
      }
      
      // 使用配置中的宽高，默认A4尺寸(595pt x 842pt)
      const canvasWidthPt = config.widthPt || 595
      const canvasHeightPt = config.heightPt || 842
      
      // 克隆DOM节点（已包含联次标识）
      const clonedCanvas = customerCanvas.cloneNode(true)
      
      // 修正画布尺寸为固定的pt单位(移除displayScale的影响)
      // 单联高度 = 总高度 / 2（因为双联时上下各一半）
      clonedCanvas.style.width = canvasWidthPt + 'pt'
      clonedCanvas.style.height = (canvasHeightPt * 0.5) + 'pt'
      
      // 清理交互属性和事件监听器
      this.cleanDOMForPrint(clonedCanvas)
      
      // 替换演示数据为占位符
      this.replaceDataWithPlaceholders(clonedCanvas)
      
      // 清理多余的数据行，只保留一行模板(合计行保留)
      this.normalizeTableRows(clonedCanvas)
      
      // 转换为HTML字符串
      let canvasHTML = clonedCanvas.outerHTML
      
      // 如果是双联，复制并修改标识
      if (config.isDuplex) {
        const stubHTML = canvasHTML.replace(/客户联/g, '存根联')
        canvasHTML += stubHTML
      }
      
      return canvasHTML
    },
    
    /**
     * 预处理函数3：组装标准HTML文档（完整模板字符串+占位符替换）
     * @param {Object} config 配置对象
     * @param {string} receiptHTML 收据HTML内容
     * @returns {string} 完整的HTML文档
     */
    assembleHTMLTemplate(config, receiptHTML) {
      const htmlTemplate = `<!DOCTYPE html>
<html lang="zh-CN">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>${config.templateName}</title>
<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { position: relative; min-height: 100vh; background: #f5f5f5; display: flex; justify-content: center; align-items: flex-start; padding-top: 20px; }
@media print { @page { size: auto; margin: 10mm; } body { print-color-adjust: exact; -webkit-print-color-adjust: exact; } .action-buttons { display: none !important; } }
.action-buttons { position: fixed; top: 20px; right: 20px; z-index: 1000; display: flex; gap: 10px; }
.btn { padding: 10px 20px; border: none; border-radius: 4px; cursor: pointer; font-size: 14px; }
.btn-primary { background: #409EFF; color: #fff; }
.btn-primary:hover { background: #66b1ff; }
.btn-default { background: #fff; color: #606266; border: 1px solid #dcdfe6; }
.btn-default:hover { border-color: #409EFF; color: #409EFF; }
.loading { text-align: center; padding: 50px; font-size: 14pt; }
.error { text-align: center; padding: 50px; font-size: 14pt; color: red; }
${RECEIPT_STYLES}
</style>
</head>
<body>
<div class="action-buttons">
  <button class="btn btn-default" onclick="window.close()">取消</button>
  <button class="btn btn-primary" onclick="window.print()">打印</button>
</div>
<div style="width: 100%; text-align: center;">
<div class="canvas-container" style="position: relative; width: ${config.widthPt}pt; height: ${config.heightPt}pt; display: inline-block; padding: 5px !important;">
<div id="app" class="receipt-container">
${receiptHTML}
</div>
</div>
</div>
<scr` + `ipt type="text/javascript">
  window.__URL_QUERY_STRING__ = "{__URL_QUERY_STRING__}";
  var AUTHORIZATION = "{__AUTHORIZATION__}";
  var TRANSACTION_ID = "{__TRANSACTION_ID__}";
  var REQUEST_TIME = "{__REQUEST_TIME__}";
  var COMMUNITY_ID = "{__COMMUNITY_ID__}";
  var COMMUNITY_NAME = "{__COMMUNITY_NAME__}";
</scr` + `ipt>
<scr` + `ipt>
${config.jsContent}
</scr` + `ipt>
</body>
</html>`
      
      return htmlTemplate
    },
    
    // 清理DOM中的交互属性
    cleanDOMForPrint(element) {
      // 移除所有事件监听器相关的属性
      const eventAttrs = ['onclick', 'onmousedown', 'onmouseup', 'onmousemove', 'onmouseleave', 'ondblclick', 'ondragover', 'ondrop']
      eventAttrs.forEach(attr => {
        element.removeAttribute(attr)
      })
      
      // 移除cursor样式(防止显示手型光标)
      if (element.style) {
        element.style.cursor = ''
      }
      
      // 移除数据标签的交互样式
      if (element.classList && element.classList.contains('data-label')) {
        element.style.background = 'transparent'
        element.style.border = 'none'
      }
      
      // 递归处理子元素
      Array.from(element.children).forEach(child => {
        this.cleanDOMForPrint(child)
      })
    },
    
    // 替换演示数据为占位符
    replaceDataWithPlaceholders(element) {
      // 替换社区名称
      if (element.textContent.includes(this.communityName)) {
        element.innerHTML = element.innerHTML.replace(new RegExp(this.communityName, 'g'), '{communityName}')
      }
      
      // 替换单号
      if (element.textContent.includes(this.receiptNo)) {
        element.innerHTML = element.innerHTML.replace(new RegExp(this.receiptNo, 'g'), '{receiptNo}')
      }
      
      // 替换业主名称
      if (element.textContent.includes(this.payName)) {
        element.innerHTML = element.innerHTML.replace(new RegExp(this.payName, 'g'), '{payName}')
      }
      
      // 替换缴费时间
      if (element.textContent.includes(this.receiptDate)) {
        element.innerHTML = element.innerHTML.replace(new RegExp(this.receiptDate, 'g'), '{receiptDate}')
      }
      
      // 替换经办人
      if (element.textContent.includes(this.collector)) {
        element.innerHTML = element.innerHTML.replace(new RegExp(this.collector, 'g'), '{collector}')
      }
      
      // 替换大写金额
      if (element.textContent.includes(this.uppercaseAmount)) {
        element.innerHTML = element.innerHTML.replace(new RegExp(this.uppercaseAmount, 'g'), '{uppercaseAmount}')
      }
      
      // 替换总金额
      if (element.textContent.includes(this.totalAmount)) {
        element.innerHTML = element.innerHTML.replace(new RegExp(this.totalAmount, 'g'), '{totalAmount}')
      }
      
      // 替换数据标签
      const labels = this.layer2Config.labels || []
      labels.forEach(label => {
        if (element.textContent.includes(label.label)) {
          element.innerHTML = element.innerHTML.replace(new RegExp(label.label, 'g'), '{' + label.field + '}')
        }
      })
      
      // 递归处理子元素
      Array.from(element.children).forEach(child => {
        this.replaceDataWithPlaceholders(child)
      })
    },
    
    // 更新联次标识
    updateCopyLabel(canvasElement, copyName) {
      // 方法1: 查找带有 .copy-label 类的元素
      const copyLabel = canvasElement.querySelector('.copy-label')
      if (copyLabel) {
        copyLabel.textContent = copyName
        return
      }
      
      // 方法2: 通过样式特征查找(兼容旧版本)
      const allDivs = canvasElement.querySelectorAll('div')
      for (let i = 0; i < allDivs.length; i++) {
        const div = allDivs[i]
        const style = div.getAttribute('style') || ''
        // 检查是否包含联次标识的特征样式
        if (style.includes('position: absolute') && 
            (style.includes('color: #f00') || style.includes('border: 2px solid #f00')) &&
            div.textContent.includes('联')) {
          div.textContent = copyName
          break
        }
      }
    },
    
    // 规范化表格行：移除多余的数据行，只保留一行模板(合计行保留)
    normalizeTableRows(canvasElement) {
      const tbody = canvasElement.querySelector('tbody')
      if (!tbody) return
      
      const allRows = Array.from(tbody.querySelectorAll('tr'))
      
      // 找出所有数据行(非合计行)
      const dataRows = allRows.filter(row => {
        // 合计行的特征：包含"大写人民币"或"合计"文本
        const text = row.textContent || ''
        return !text.includes('大写人民币') && !text.includes('合计')
      })
      
      // 如果有多余的数据行，只保留第一行作为模板
      if (dataRows.length > 1) {
        for (let i = 1; i < dataRows.length; i++) {
          tbody.removeChild(dataRows[i])
        }
      }
    },
    
    // 生成内联JavaScript脚本
    /**
     * 生成内联JavaScript脚本（完整模板字符串+占位符替换）
     * @returns {string} 完整的JS脚本字符串
     */
    generateInlineScript() {
      const tableColumns = JSON.stringify(this.layer2Config.tableColumns || [])
      
      const scriptTemplate = `
function numberToChinese(num) {
  if (num === null || num === undefined || num === '' || isNaN(num)) return "零";
  // 取绝对值转换（退费收据不在此处加"负"，由调用方处理业务语义）
  num = Math.abs(parseFloat(num));
  if (num === 0) return "零";
  var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  var unit = ["元", "万", "亿"];
  var intPart = Math.floor(num);
  var decPart = Math.round((num - intPart) * 100);
  var result = "";
  var intStr = intPart.toString();
  var unitIndex = 0;
  while (intStr.length > 0) {
    var section = parseInt(intStr.slice(-4), 10);
    var sectionStr = "";
    for (var i = 0; i < 4 && section > 0; i++) {
      var d = section % 10;
      sectionStr = digit[d] + (i === 0 ? "" : ["", "拾", "佰", "仟"][i]) + sectionStr;
      section = Math.floor(section / 10);
    }
    if (sectionStr) {
      result = sectionStr + unit[unitIndex] + result;
    } else if (unitIndex > 0 && result) {
      result = unit[unitIndex] + result;
    }
    intStr = intStr.slice(0, -4);
    unitIndex++;
  }
  if (decPart > 0) {
    var decInt = Math.floor(decPart / 10);
    var decDec = decPart % 10;
    if (decInt > 0) result += digit[decInt] + "角";
    if (decDec > 0) result += digit[decDec] + "分";
  } else {
    result += "整";
  }
  return result || "零";
}

var TABLE_COLUMNS = [];
var TABLE_HEADERS = [];
var TABLE_FIELDS = [];
try {
  var cols = ${tableColumns};
  if (cols && cols.length > 0) {
    TABLE_COLUMNS = cols;
    TABLE_HEADERS = cols.map(function(col) { return col.header; });
    TABLE_FIELDS = cols.map(function(col) { return col.field; });
  }
} catch(e) { console.log("[收据模板] 表格配置解析失败:", e); }

console.log("[收据模板] 表格字段:", TABLE_FIELDS);

function parseUrlParams() {
  var params = {};
  var queryString = window.__URL_QUERY_STRING__ || window.location.search.substring(1);
  if (!queryString) return params;
  var pairs = queryString.split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    if (pair.length === 2) {
      params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
  }
  return params;
}

function getUrlParam(name) {
  var params = parseUrlParams();
  return params[name] || null;
}

function init() {
  var receiptId = getUrlParam("receiptId");
  var receiptIds = getUrlParam("receiptIds");
  var detailIds = getUrlParam("detailIds");
  var merge = getUrlParam("merge");

  if (receiptId || receiptIds || detailIds) {
    var apiParams = "page=1&row=30&communityId=" + COMMUNITY_ID;
    if (receiptId) { apiParams += "&receiptId=" + receiptId; }
    if (receiptIds) { apiParams += "&receiptIds=" + receiptIds; }
    if (detailIds) { apiParams += "&detailIds=" + detailIds; }
    var apiUrl = "/app/feeReceipt/queryFeeReceipt?" + apiParams;
    fetch(apiUrl, {
      headers: {
        "Authorization": AUTHORIZATION,
        "app-id": "8000418004",
        "TRANSACTION-ID": TRANSACTION_ID,
        "REQ-TIME": REQUEST_TIME
      }
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        console.log("[收据模板] 收据数据:", data);
        if (data && data.code === 0 && data.data) {
          var detailParams = "page=1&row=100&communityId=" + COMMUNITY_ID;
          if (receiptId) { detailParams += "&receiptId=" + receiptId; }
          if (receiptIds) { detailParams += "&receiptIds=" + receiptIds; }
          if (detailIds) { detailParams += "&detailIds=" + detailIds; }
          var detailUrl = "/app/feeReceipt/queryFeeReceiptDetail?" + detailParams;
          fetch(detailUrl, {
            headers: {
              "Authorization": AUTHORIZATION,
              "app-id": "8000418004",
              "TRANSACTION-ID": TRANSACTION_ID,
              "REQ-TIME": REQUEST_TIME
            }
          })
          .then(function(detailResponse) {
            return detailResponse.json();
          })
          .then(function(detailData) {
            console.log("[收据模板] 明细数据:", detailData);
            if (detailData && detailData.code === 0 && detailData.data) {
              var allReceipts = data.data || [];
              var allDetails = detailData.data || [];

              // 步骤1：获取第一条收据作为基础数据（包含标题、头信息、底部信息）
              var receiptData = allReceipts[0] || {};

              // 步骤2：字段映射到收据数据（用于标题、头信息、底部信息）
              // 优先级策略：参考项目中5个硬编码打印模板的字段使用方式
              
              // 小区名称：优先取 communityName，其次 COMMUNITY_NAME 全局变量
              receiptData.communityName = receiptData.communityName 
                || COMMUNITY_NAME 
                || receiptData.community 
                || "";

              // 收据编号：优先取 receiptCode（后端标准字段），其次 receiptNo
              receiptData.receiptNo = receiptData.receiptCode 
                || receiptData.receiptNo 
                || receiptData.code 
                || "";

              // 缴费人：优先取 payObjName（后端标准字段），其次 payName
              receiptData.payName = receiptData.payObjName 
                || receiptData.payName 
                || receiptData.ownerName 
                || "";

              // 缴费时间：优先取 createTime（后端标准字段），其次 feeTime/receiptDate
              receiptData.receiptDate = receiptData.createTime 
                || receiptData.feeTime 
                || receiptData.receiptDate 
                || receiptData.payTime 
                || "";

              // 房屋/车辆名称
              receiptData.roomName = receiptData.objName 
                || receiptData.roomName 
                || receiptData.room 
                || "";
              
              // 经办人/收费员：支持多种字段名
              receiptData.collector = receiptData.collector 
                || receiptData.operatorName 
                || receiptData.userName 
                || receiptData.handler 
                || "";
              
              // 其他基础字段
              receiptData.storeName = receiptData.storeName || "";
              receiptData.content = receiptData.content || "";
              receiptData.qrImg = receiptData.qrImg || "";

              // 步骤3：匹配收据和明细，生成表格数据
              // 根据配置好的表头字段名（TABLE_FIELDS）去匹配每条明细
              // 引入字段别名映射：设计器配置的字段名可能与后端返回的字段名不同
              var FIELD_ALIASES = {
                'payMethod': ['primeRate', 'payMethod'],
                'unitPrice': ['squarePrice', 'unitPrice'],
                'discount': ['discountPrice', 'discount'],
                'period': ['cycle', 'period']
              };

              // 辅助函数：根据设计器字段名从数据源中解析真实值
              function resolveFieldValue(fieldName, detail, receipt) {
                // 1. 先尝试直接从明细中取
                if (detail[fieldName] !== null && detail[fieldName] !== undefined && detail[fieldName] !== '') {
                  return detail[fieldName];
                }
                // 2. 尝试从收据中取
                if (receipt[fieldName] !== null && receipt[fieldName] !== undefined && receipt[fieldName] !== '') {
                  return receipt[fieldName];
                }
                // 3. 如果有别名配置，按优先级尝试别名
                var aliases = FIELD_ALIASES[fieldName];
                if (aliases) {
                  for (var a = 0; a < aliases.length; a++) {
                    var alias = aliases[a];
                    if (alias === fieldName) continue;  // 跳过已查过的原名
                    if (detail[alias] !== null && detail[alias] !== undefined && detail[alias] !== '') {
                      return detail[alias];
                    }
                    if (receipt[alias] !== null && receipt[alias] !== undefined && receipt[alias] !== '') {
                      return receipt[alias];
                    }
                  }
                }
                // 4. 都没找到，返回空字符串
                return '';
              }

              var tableDetails = [];
              allReceipts.forEach(function(receipt) {
                var receiptDetails = allDetails.filter(function(detail) {
                  return detail.receiptId === receipt.receiptId;
                });
                if (receiptDetails.length > 0) {
                  receiptDetails.forEach(function(detail) {
                    // 预处理合成字段：feePeriod 由 startTime + endTime 合成
                    if (!detail.feePeriod && detail.startTime && detail.endTime) {
                      detail.feePeriod = detail.startTime + '至' + detail.endTime;
                    }
                    
                    var tableRow = {};
                    
                    // 用配置的字段名 + 别名解析 去匹配明细数据
                    TABLE_FIELDS.forEach(function(field) {
                      tableRow[field] = resolveFieldValue(field, detail, receipt);
                    });
                    
                    // 特殊处理：编号字段使用收据编号
                    if (TABLE_FIELDS.indexOf('rowIndex') !== -1) {
                      tableRow.rowIndex = receipt.receiptCode || receipt.receiptNo || '';
                    }
                    
                    tableDetails.push(tableRow);
                  });
                }
              });

              // 步骤4：处理表格数据的计算字段和金额汇总
              // 注意：字段别名映射已在步骤3中通过 resolveFieldValue 完成
              // 此步骤仅处理：feePeriod合成、金额计算等计算型字段
              var totalAmount = 0;
              var amountFields = ['amount', 'receivableAmount', 'feeAmount'];
              
              tableDetails.forEach(function(row, index) {
                // ========== 基础字段默认值 ==========
                row.feeName = row.feeName || '';
                row.objName = row.objName || '';
                row.remark = row.remark || '';
                
                // ========== 时间范围合成 ==========
                // feePeriod 可能已由别名解析获取，也可能是由 startTime + endTime 合成
                row.startTime = row.startTime || '';
                row.endTime = row.endTime || '';
                if (!row.feePeriod && row.startTime && row.endTime) {
                  row.feePeriod = row.startTime + '至' + row.endTime;
                }
                row.feePeriod = row.feePeriod || '';
                
                // ========== 金额计算（核心逻辑）==========
                var amount = 0;
                var foundAmountField = null;
                
                // 按优先级查找金额字段：amount > receivableAmount > feeAmount
                for (var i = 0; i < amountFields.length; i++) {
                  var field = amountFields[i];
                  if (row[field] !== null && row[field] !== undefined && row[field] !== '') {
                    var rawValue = String(row[field]);
                    // 清理货币符号和空格
                    var cleanedValue = rawValue.replace(/[¥￥$, ]/g, '');
                    var parsed = parseFloat(cleanedValue);
                    if (!isNaN(parsed)) {
                      amount = parsed;
                      foundAmountField = field;
                      break;
                    }
                  }
                }
                
                // 记录调试信息
                if (foundAmountField === null) {
                }
                
                // 使用 Math.round 避免浮点数精度问题（如 0.1 + 0.2 = 0.30000000000000004）
                amount = Math.round(amount * 100) / 100;
                totalAmount = Math.round((totalAmount + amount) * 100) / 100;
                
                // 统一金额字段为 amount（保留两位小数）
                row.amount = amount.toFixed(2);
                
                // 退费标记：金额为负时，在费用名称后追加（退费）
                if (amount < 0) {
                  row.feeName = (row.feeName || '') + '<b>（退费）</b>';
                }
              });

              // 步骤5：设置合计信息
              // 退费收据：合计为负时使用绝对值，并标记isRefund
              var isRefund = totalAmount < 0;
              var displayTotal = isRefund ? Math.abs(totalAmount) : totalAmount;
              receiptData.details = tableDetails;
              receiptData.totalAmount = displayTotal.toFixed(2);
              receiptData.uppercaseAmount = numberToChinese(displayTotal);
              receiptData.isRefund = isRefund;

              console.log("[收据模板] 待渲染数据:", receiptData);
              renderReceiptData(receiptData);
            } else {
              console.error("[收据模板] 明细加载失败:", detailData);
              document.getElementById("app").innerHTML = "<div class='error'>加载明细失败：" + (detailData.msg || "未知错误") + "</div>";
            }
          })
          .catch(function(error) {
            console.error("[收据模板] 明细请求失败:", error);
            document.getElementById("app").innerHTML = "<div class='error'>加载明细失败</div>";
          });
        } else {
          console.error("[收据模板] 数据加载失败:", data);
          document.getElementById("app").innerHTML = "<div class='error'>加载失败：" + (data.msg || "未知错误") + "</div>";
        }
      })
      .catch(function(error) {
        console.error("[收据模板] 网络请求失败:", error);
        document.getElementById("app").innerHTML = "<div class='error'>网络请求失败</div>";
      });
  } else if (detailIds) {
    fetch("/callComponent/fee/feeApi/queryFeeDetailByIds?detailIds=" + detailIds + "&merge=" + (merge || "false") + "&communityId=" + COMMUNITY_ID, {
      headers: {
        "Authorization": AUTHORIZATION,
        "app-id": "8000418004",
        "TRANSACTION-ID": TRANSACTION_ID,
        "REQ-TIME": REQUEST_TIME
      }
    })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data && data.code === 0 && data.data) {
          renderReceiptData(data.data);
        } else {
          console.error("[收据模板] 数据加载失败:", data);
          document.getElementById("app").innerHTML = "<div class='error'>加载失败：" + (data.msg || "未知错误") + "</div>";
        }
      })
      .catch(function(error) {
        console.error("[收据模板] 网络请求失败:", error);
        document.getElementById("app").innerHTML = "<div class='error'>网络请求失败</div>";
      });
  } else {
    document.getElementById("app").innerHTML = "<div class='error'>缺少必要参数</div>";
  }
}

function renderReceiptData(data) {
  var app = document.getElementById("app");
  if (!app) return;

  // 步骤1：先替换所有文本占位符（表头信息）
  var html = app.innerHTML;
  html = html.replace(/{communityName}/g, data.communityName || "");
  html = html.replace(/{receiptNo}/g, data.receiptNo || "");
  html = html.replace(/{payName}/g, data.payName || "");
  html = html.replace(/{receiptDate}/g, data.receiptDate || "");
  html = html.replace(/{collector}/g, data.collector || "");
  html = html.replace(/{uppercaseAmount}/g, data.uppercaseAmount || numberToChinese(data.totalAmount));
  html = html.replace(/{totalAmount}/g, data.totalAmount || "0.00");
  
  // 替换其他数据标签
  for (var key in data) {
    if (data.hasOwnProperty(key) && key !== "details") {
      html = html.replace(new RegExp("{" + key + "}", "g"), data[key] || "");
    }
  }
  
  // 最终兜底：清除所有未被匹配的 {xxx} 占位符
  html = html.replace(/{[^}]+}/g, "");
  
  // 应用文本替换到DOM
  app.innerHTML = html;

  // 退费收据：合计标签改为"合计（退费）"
  if (data.isRefund) {
    var amountTotalCells = document.querySelectorAll(".amount-total-row td");
    for (var c = 0; c < amountTotalCells.length; c++) {
      var cellText = (amountTotalCells[c].textContent || '').trim();
      if (cellText === '合计' || cellText.indexOf('合计') === 0) {
        amountTotalCells[c].innerHTML = '合计<b>（退费）</b>';
      }
    }
  }

  // 步骤2：再处理表格数据行（DOM操作）
  if (data.details && data.details.length > 0 && TABLE_FIELDS && TABLE_FIELDS.length > 0) {
    var tbodys = document.querySelectorAll(".receipt-table-body");
    tbodys.forEach(function(tbody) {
      // 保留合计行：大写人民币行 + 金额合计行
      var isSummaryRow = function(row) {
        return row.classList.contains("total-row") || row.classList.contains("amount-total-row");
      };
      var summaryRows = [];
      var rows = tbody.querySelectorAll("tr");
      for (var i = rows.length - 1; i >= 0; i--) {
        if (!isSummaryRow(rows[i])) {
          tbody.removeChild(rows[i]);
        } else {
          summaryRows.unshift(rows[i]);
        }
      }

      // 在第一个合计行之前插入数据行
      var insertTarget = summaryRows.length > 0 ? summaryRows[0] : null;
      var newRowsHTML = "";
      data.details.forEach(function(row, rowIndex) {
        var tr = "<tr>";
        TABLE_FIELDS.forEach(function(field) {
          var value = row[field] !== null && row[field] !== undefined ? row[field] : "";
          tr += "<td>" + value + "</td>";
        });
        tr += "</tr>";
        newRowsHTML += tr;
      });

      if (insertTarget) {
        insertTarget.insertAdjacentHTML("beforebegin", newRowsHTML);
      } else {
        tbody.innerHTML = newRowsHTML;
      }
    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
      `.trim()
      
      return scriptTemplate
    },
    
    generateDemoTableRowsJS() {
      const cols = this.layer2Config.tableColumns || []
      const rows = this.layer2Config.defaultRows || 2
      const rowDataList = []
      for (let i = 0; i < rows; i++) {
        const rowData = {}
        cols.forEach(col => {
          if (col.field === 'rowIndex') rowData[col.field] = i + 1
          else if (col.field === 'amount') rowData[col.field] = (Math.random() * 100 + 50).toFixed(2)
          else rowData[col.field] = col.header || '-'
        })
        rowDataList.push(JSON.stringify(rowData))
      }
      return rowDataList.join(', ')
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).catch(() => {
          this.fallbackCopy(text)
        })
      } else {
        this.fallbackCopy(text)
      }
    },
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }
  }
}
</script>

<style scoped>
.template-designer-container {
  padding: 20px;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.designer-main {
  display: flex;
  gap: 20px;
  flex: 1;
  min-height: 0;
}

/* 左侧画布区域 */
.canvas-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  border-radius: 8px;
  padding: 10px;  /* 减小内边距 */
  overflow: auto;  /* 改回auto，支持滚动 */
  min-width: 0;
}

.canvas-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.canvas-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.canvas-size {
  font-size: 12px;
  color: #666;
}

.scale-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
  padding: 8px;
  background: #fff;
  border-radius: 4px;
}

.canvas-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;  /* 垂直排列 */
  justify-content: flex-start;  /* 从顶部开始，避免遮挡 */
  align-items: center;      /* 水平居中 */
  overflow: visible;        /* 改为visible，不产生滚动条 */
  padding: 10px 0;          /* 只保留上下padding，左右为0 */
}

.design-canvas {
  background: #fff;
  border: 2px solid #409EFF;  /* 添加边框 */
  position: relative;  /* 确保子元素可以绝对定位 */
  flex-shrink: 0;  /* 防止flex布局压缩高度 */
  /* 移除 overflow: hidden，允许内容溢出，实现纯流式布局 */
}

/* 收据样式 */
.receipt-header {
  text-align: center;
}

.receipt-title {
  font-size: 1.6em;
}

.receipt-subtitle {
  font-size: 0.6em;
  color: #666;
  margin-top: 5px;
}

.header-info {
  display: flex;
  justify-content: space-between;
}

.info-row {
  margin-bottom: 5px;
}

.info-label {
  font-weight: bold;
}

.receipt-table-wrapper {
  overflow: auto;
}

.receipt-table {
  width: 100%;
  border-collapse: collapse;
}

.receipt-table th,
.receipt-table td {
  border: 1px solid #ccc;
  padding: 2px;
  text-align: center;
}

.receipt-table th {
  background: #f5f5f5;
  font-weight: bold;
}

.total-row {
  background: #f9f9f9;
}

.amount-total-row {
  background: #e8f4ff;
  font-weight: bold;
}

.total-label {
  text-align: left;
  padding-left: 10px;
}

.total-value {
  text-align: right;
  padding-right: 10px;
}

.footer-info {
  display: flex;
  justify-content: space-between;
}

.footer-left,
.footer-center,
.footer-right {
  text-align: center;
  width: 25%;
}

.watermark-layer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
}

.stamp-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  pointer-events: none;  /* 让鼠标事件穿透到下方元素 */
}

.stamp-layer img {
  opacity: 0.8;
  pointer-events: auto;  /* 印章图片需要接收鼠标事件 */
}

.copy-label {
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #f00;
  border: 2px solid #f00;
  padding: 4px 10px;
  z-index: 100;
  background: rgba(255, 255, 255, 0.9);
}

.data-label {
  cursor: move;
  padding: 4px 8px;
  background: rgba(255, 255, 0, 0.3);
  border: 1px dashed #333;
  white-space: nowrap;
  z-index: 10;
}

/* 右侧配置面板 */
.config-section {
  width: 380px;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  overflow: auto;
  flex-shrink: 0;
}

.config-tabs-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.config-tabs-wrapper .el-tabs {
  flex: 1;
  margin-bottom: 0;
}

.table-config {
  padding: 10px 0;
}

.table-columns-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 4px;
}

.column-item {
  margin-bottom: 10px;
  padding: 10px;
  background: #fafafa;
  border-radius: 4px;
}

.empty-tip {
  color: #999;
  text-align: center;
  padding: 20px;
}

.table-rows-config {
  margin-top: 15px;
  padding: 10px;
  background: #f0f0f0;
  border-radius: 4px;
}

.field-list {
  margin-top: 15px;
  padding: 10px;
  background: #e8f4ff;
  border-radius: 4px;
}

.field-list h4 {
  margin-bottom: 10px;
  color: #409EFF;
}

.field-item {
  display: inline-block;
  padding: 5px 10px;
  margin: 5px;
  background: #fff;
  border: 1px solid #409EFF;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.field-item:hover {
  background: #409EFF;
  color: #fff;
}

.label-list {
  margin-top: 15px;
  padding: 10px;
}

.label-list h4 {
  margin-bottom: 10px;
  color: #333;
}

.preview-box {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.preview-img {
  max-width: 100px;
  max-height: 100px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.stamp-preview {
  border-radius: 50%;
}

.size-tip {
  color: #999;
  font-size: 12px;
  margin-left: 10px;
}

/* Element UI 样式覆盖 */
.el-form-item {
  margin-bottom: 15px;
}

.el-slider {
  margin: 10px 0;
}

.el-table {
  margin-top: 10px;
}

/* Flex 布局辅助类 */
.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}
</style>